import i18n, { ResourceLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Lang } from '@/types';
import { en, id, setLangStorage } from '@/locale';
import { regexIsEn } from '@/utils/helper';

// the translations
const resources: {
  [keys in Lang]: ResourceLanguage;
} = {
  en,
  id,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(
    {
      resources,
      fallbackLng: {
        default: ['id'],
      },
      keySeparator: false, // we do not use keys in form messages.welcome
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    },
    err => {
      if (!err) {
        const currentLang = i18n.language as Lang;
        // NOTE: fallback "en-US" to "en" when user lang is en-US and lng param not exist
        if (regexIsEn(currentLang)) {
          setLangStorage('en');
          return;
        }
        setLangStorage(currentLang);
      }
    }
  );

export default i18n;
